import { FaFire, FaShieldAlt, FaSearch, FaClock, FaFileAlt } from "react-icons/fa";
import { FiIconName } from 'react-icons/fi';
import { FaIconName } from 'react-icons/fa';


export default function Pericias() {
  return (
    <section id="pericias" className="bg-gray-900 text-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Título */}
        <h2 className="text-4xl font-bold text-center mb-10">Pericias en Incendios</h2>

        {/* Descripción */}
        <p className="text-lg text-gray-400 text-center max-w-3xl mx-auto mb-12">
        Ofrezco un servicio de Investigación de Incendios de alta calidad, dirigido a aseguradoras, abogados, empresas, entidades gubernamentales y particulares que requieren información precisa luego de un siniestro. Utilizando técnicas avanzadas, mi objetivo es descubrir la verdad detrás del fuego, analizando causas, daños y riesgos para proporcionar informes detallados y verificables. Este servicio es esencial para validar coberturas de seguros, preparar estrategias legales, evaluar incidentes en empresas o refutar pericias previas. Cada investigación se basa en evidencia física, química y forense para garantizar resultados claros y confiables.
        </p>

        {/* Beneficios / Características */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Tarjeta 1 */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <FaFire className="text-red-500 text-4xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Determinación de la Causa y Análisis de Riesgos</h3>
            <p className="text-gray-400">
            Identifico el origen y la causa del incendio, ya sea accidental, intencional o por fallos técnicos, y evalúo los riesgos asociados para prevenir futuros incidentes.
            </p>
          </div>

          {/* Tarjeta 2 */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <FaShieldAlt className="text-blue-500 text-4xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Soporte Legal y de Seguros</h3>
            <p className="text-gray-400">
            Proporciono pruebas clave para reclamaciones de seguros y procesos judiciales, ayudando a clarificar responsabilidades y asegurar una compensación justa.
            </p>
          </div>

          {/* Tarjeta 3 */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <FaSearch className="text-green-500 text-4xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Mejora en la Seguridad y Prevención</h3>
            <p className="text-gray-400">
            Brindo asesoramiento para optimizar protocolos de seguridad, implementar medidas correctivas y proteger a personas e infraestructuras ante futuros riesgos.
            </p>
          </div>

          {/* Tarjeta 4 */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <FaClock className="text-yellow-500 text-4xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Cumplimiento Normativo y Protección de Bienes</h3>
            <p className="text-gray-400">
            Ayudo a garantizar que los edificios cumplan con las regulaciones de seguridad contra incendios, minimizando sanciones y protegiendo activos y vidas.
            </p>
          </div>

          {/* Tarjeta 5 */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition">
            <FaFileAlt className="text-purple-500 text-4xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">Capacitación y Desarrollo de Planes de Emergencia</h3>
            <p className="text-gray-400">
            Ofrezco entrenamientos especializados para profesionales y empresas en investigación de incendios, y desarrollo planes de emergencia eficientes, asegurando respuestas rápidas y efectivas ante incendios.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
